module.exports = __webpack_public_path__ + "static/media/pen-square.2062d78d.svg";